import React from 'react';
import { FadeIn } from './FadeIn';
import { Rocket } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-12 lg:pt-16 lg:pb-16 overflow-hidden bg-gradient-to-br from-brand-50 via-brand-100 to-amber-50" data-id="element-68" data-mp="2hvvt1ryn1lfa">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-69" data-mp="23x4mcqm3v216">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-200/40 blur-3xl" data-id="element-70" data-mp="28uo6g75hi911"></div>
        <div className="absolute top-[40%] -right-[10%] w-[40%] h-[60%] rounded-full bg-orange-200/40 blur-3xl" data-id="element-71" data-mp="2wltmambfd1bc"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-72" data-mp="2mu5o82kd4m0w">
        <div className="max-w-4xl mx-auto text-center" data-id="element-73" data-mp="2mrtbq4xdj3v8">
          <FadeIn data-id="element-74" data-mp="2rs7cd1wnbbj8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight mb-4" data-id="element-75" data-mp="2rrpdrymigl85">
              ¿Sentís que el tiempo con tus hijos se te escapa entre las
              pantallas? <span className="inline-block" data-id="element-76" data-mp="3ka34le9fj6xq">🕒</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-77" data-mp="2fgjyovc11inl">
            <div className="max-w-md mx-auto mb-4" data-id="element-78" data-mp="2fdfnhe059mnf">
              <img src="https://cdn.magicpatterns.com/uploads/gdoNaevVERZnpGkuzwxwbb/WhatsApp_Image_2026-04-05_at_18.28.17_(1).jpg" alt="Pack 100 Citas con mi Hijo e Hija" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-79" data-mp="2beq2p0cs12tr" />
            </div>
          </FadeIn>

          <FadeIn delay={0.25} data-id="element-80" data-mp="2z26ij3iuv53t">
            <p className="text-lg md:text-xl text-slate-700 mb-5 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-81" data-mp="2z5lxm6cj4e58">
              Recuperá la conexión real con el{' '}
              <span className="font-bold text-brand-700" data-id="element-82" data-mp="382weq8c12xi2">
                Pack 100 Citas Family
              </span>
              . Guías listas para crear recuerdos inolvidables, sin planificar y
              sin gastar una fortuna.
            </p>
          </FadeIn>

          <FadeIn delay={0.35} data-id="element-83" data-mp="18rlerajq8aeb">
            <a href="#comprar" className="inline-flex items-center justify-center gap-3 bg-brand-500 hover:bg-brand-600 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-xl shadow-brand-500/30 transition-all hover:scale-105 hover:shadow-brand-500/50 active:scale-95 w-full sm:w-auto" data-id="element-84" data-mp="18smsxnw1hd09">
              ¡SÍ, QUIERO EL PACK AHORA! <Rocket className="w-6 h-6" data-id="element-85" data-mp="3mtcizt2q8ie0" />
            </a>
            <p className="mt-3 text-sm text-slate-500 font-medium" data-id="element-86" data-mp="3mqrib7e608hu">
              Acceso inmediato • Pago 100% seguro
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}